import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';

export interface ClassesToUseIgnoreRadioProps {
  isToIgnore: boolean;
  updateIsToIgnore: (isToIgnore: boolean) => void;
}

const ClassesToUseIgnoreRadioButtons: React.FC<React.PropsWithChildren<ClassesToUseIgnoreRadioProps>> = ({
  isToIgnore,
  updateIsToIgnore,
}) => {
  return (
    <FormControl>
      <FormLabel sx={{ color: 'text.primary', '&.Mui-focused': { color: 'text.primary' } }}>Class filtering</FormLabel>
      <RadioGroup
        value={String(isToIgnore)}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          updateIsToIgnore(event.target.value === 'true');
        }}
      >
        <FormControlLabel value="false" control={<Radio size="small" />} label="Classes To Use" />
        <FormControlLabel value="true" control={<Radio size="small" />} label="Classes To Ignore" />
      </RadioGroup>
    </FormControl>
  );
};
export default ClassesToUseIgnoreRadioButtons;
